import { render, staticRenderFns } from "./Introduct.vue?vue&type=template&id=26a98fc0&scoped=true&"
import script from "./Introduct.vue?vue&type=script&lang=js&"
export * from "./Introduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a98fc0",
  null
  
)

export default component.exports